module.exports = __webpack_public_path__ + "img/mobukuBScrn1.142d5d45.png";